import "./App.scss";
import Header from "./Header";
import Footer from "./Footer";
import Home from "./Main/Home";
import { Contact } from "./Main/Contact";
import { Routes, Route } from "react-router-dom";
import { useRef } from "react";

function App() {
  const navBar = useRef<HTMLElement>(null);

  function handleScroll() {
    const scrollTop = document.documentElement.scrollTop;
    if (scrollTop > 50) {
      navBar?.current?.classList.add("scrollDown");
      navBar?.current?.classList.remove("scrollUp");
    } else {
      navBar?.current?.classList.add("scrollUp");
      navBar?.current?.classList.remove("scrollDown");
    }
  }

  window.addEventListener("scroll", handleScroll);

  return (
    <>
      <header className="app-header" ref={navBar}>
        <Header />
      </header>
      <div className="app-main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <div className="app-footer">
          <Footer />
        </div>
      </div>
    </>
  );
}

export default App;
